<tt-page *ngIf="!!belongTo">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgEdit">
                <tt-tab ttId="structure" ttLabel="structure"></tt-tab>
                <tt-tab ttId="edit" ttLabel="edit"></tt-tab>
            </tt-tabs>

            <tt-input *ngIf="!!linkCategory" ttLabel="belongto_name" [ttModel]="linkCategory.belongto_name" ttReadonly></tt-input>

            <div [hidden]="selectedBgEdit !== 'structure'">
                <ng-container *ngTemplateOutlet="structureFields"></ng-container>
                <tt-button-goto ttText="add_new_category_child" ttGoto="categorylinkadd" [ttGotoParms]="{ category_keyno_belongto: categoryKeynoBelongTo }" ttIcon="far fa-plus"></tt-button-goto>
            </div>

            <div [hidden]="selectedBgEdit !== 'edit'">
                <tt-input ttLabel="category_name" [(ttModel)]="belongTo.category_name"></tt-input>
                <tt-input *ngFor="let item of inputListLanguages" [ttLabel]="item.language_name" [(ttModel)]="item.category_name"></tt-input>
                <ng-container *ngTemplateOutlet="buttonSaveDelete"></ng-container>
            </div>
        </tt-card>

        <tt-list [hidden]="selectedBgEdit !== 'structure'" [ttData]="itemsListCategoryLinks" [ttBadge]="'item_badge'"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="categorylinks_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="structure">
                        <tt-input *ngIf="!!linkCategory" ttLabel="belongto_name" [ttModel]="linkCategory.belongto_name" ttReadonly></tt-input>
                        <ng-container *ngTemplateOutlet="structureFields"></ng-container>
                        <tt-input ttLabel="category_name" [(ttModel)]="belongTo.category_name"></tt-input>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="35">
                    <tt-card class="col-xs-12 p-5" ttHeading="h_list_nobbs">
                        <tt-button-goto ttText="add_new_category_child" ttGoto="categorylinkadd" [ttGotoParms]="{ category_keyno_belongto: categoryKeynoBelongTo }" ttIcon="far fa-plus"></tt-button-goto>
                    </tt-card>

                    <tt-list class="col-xs-12 p-5" [ttData]="itemsListCategoryLinks" [ttBadge]="'item_badge'"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="35">
                    <tt-card class="col-xs-12 p-5" ttHeading="edit">
                        <tt-input *ngFor="let item of inputListLanguages" [ttLabel]="item.language_name" [(ttModel)]="item.category_name"></tt-input>
                        <ng-container *ngTemplateOutlet="buttonSaveDelete"></ng-container>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #structureFields>
    <ng-container *ngIf="!!belongTo">
        <tt-input ttLabel="category_name" [ttModel]="belongTo.category_name" ttReadonly></tt-input>
        <tt-input ttLabel="category_product_count" [ttModel]="belongTo.item_badge" [ttButtons]="productCountButtons" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttonSaveDelete>
    <ng-container *ngIf="!!inputListLanguages">
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="categoryLinkKeyno !== '0'" ttText="delete_link" (ttClick)="deleteCategoryLink()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deletingLink"></tt-button>
        <tt-button ttText="delete_category" (ttClick)="deleteCategory()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deletingCategory"></tt-button>
    </ng-container>
</ng-template>
